import { useEffect, useState } from "react";
import { useUserData } from "src/context/userContext";
import { stat_getStat3 } from "src/data/stat/statFunctions";
import Stat_pumppari_PersonKeikkaCountChart from "./Stat_pumppari_PersonKeikkaCountChart";
import Stat_pumppari_KeikkaMinutesChart from "./Stat_pumppari_KeikkaMinutesChart";
import Stat_pumppari_MonthlyM3Chart from "./Stat_pumppari_MonthlyM3Chart";
import { Select, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import {
  parse,
  isSameMonth,
  isAfter,
  isBefore,
  min as dateFnsMin,
  max as dateFnsMax,
} from "date-fns";

export default function Stat_pumppari() {
  const { user, userAsiakas, token } = useUserData();
  const [data, setData] = useState([]);
  const [selectedPumppari, setSelectedPumppari] = useState("");
  const [pumppariList, setPumppariList] = useState([]);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  useEffect(() => {
    const fetchPumppariData = async () => {
      const pumppuAsiakasId = userAsiakas.isPumppuToimittaja ? userAsiakas.asiakasId : null;
      const betoniAsiakasId = userAsiakas.isBetoniToimittaja ? userAsiakas.asiakasId : null;
      const ownerAsiakasId = userAsiakas.asiakasId;
      const a = await stat_getStat3(pumppuAsiakasId, betoniAsiakasId, ownerAsiakasId, token);
      setData(a);

      // Extract unique person names (pumppari)
      const uniquePumpparis = [...new Set(a.map((item) => item.pumppari))];
      setPumppariList(uniquePumpparis);

      // Set default selected pumppari
      if (uniquePumpparis.length > 0) {
        if (userAsiakas.auth.isAsiakasAdmin) setSelectedPumppari(uniquePumpparis[0]);
        else if (userAsiakas.auth.isPumppari) setSelectedPumppari(user.personFullName);
      }

      // Set default start and end months
      const dateMonths = a.map((item) =>
        parse(`${item.year}-${item.month}-01`, "yyyy-M-d", new Date())
      );
      if (dateMonths.length > 0) {
        const minDate = dateFnsMin(dateMonths);
        const maxDate = dateFnsMax(dateMonths);
        setStartMonth(minDate);
        setEndMonth(maxDate);
      }
    };
    fetchPumppariData();
  }, []);

  // Filter data based on selected pumppari and date range
  const filteredData = data.filter((item) => {
    const itemDate = parse(`${item.year}-${item.month}-01`, "yyyy-M-d", new Date());
    const isPumppariMatch = item.pumppari === selectedPumppari;
    const isDateInRange =
      (isAfter(itemDate, startMonth) || isSameMonth(itemDate, startMonth)) &&
      (isBefore(itemDate, endMonth) || isSameMonth(itemDate, endMonth));
    return isPumppariMatch && isDateInRange;
  });

  return (
    <div style={{ paddingTop: 10 }}>
      <div></div>
      <div>
        <div className="center" style={{ gap: 6, flexWrap: "wrap" }}>
          <Select
            labelId="pumppari-label"
            id="pumppari"
            value={selectedPumppari}
            disabled={userAsiakas.auth.isAsiakasAdmin ? false : true}
            onChange={(e) => setSelectedPumppari(e.target.value)}>
            {pumppariList.map((pumppari) => (
              <MenuItem key={pumppari} value={pumppari}>
                {pumppari}
              </MenuItem>
            ))}
          </Select>
          <div className="center" style={{ gap: 6 }}>
            <DatePicker
              views={["year", "month"]}
              label="Alkaen kk"
              minDate={new Date("2012-01-01")}
              maxDate={new Date()}
              value={startMonth}
              onChange={(newValue) => setStartMonth(newValue)}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
            -
            <DatePicker
              views={["year", "month"]}
              label="Päättyen kk"
              minDate={new Date("2012-01-01")}
              maxDate={new Date()}
              value={endMonth}
              onChange={(newValue) => setEndMonth(newValue)}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </div>
        </div>
      </div>
      {selectedPumppari && filteredData.length > 0 ? (
        <>
          <Stat_pumppari_MonthlyM3Chart data={filteredData} />
          <Stat_pumppari_PersonKeikkaCountChart data={filteredData} />
          <Stat_pumppari_KeikkaMinutesChart data={filteredData} />
        </>
      ) : (
        <div className="center">
          <p>Ei dataa aikavälillä</p>
        </div>
      )}
    </div>
  );
}
